module.exports = __webpack_public_path__ + "img/capa-hover-simulado.74fc1290.png";